// RETAIL
// MAIL_ORDERS

export enum PharmacyType {
  RETAIL = 'RETAIL',
  MAIL_ORDERS = 'MAIL_ORDERS'
}
